module.exports = "/img/book_default_1.697864e3.jpg";